import React from 'react'
import PropTypes from 'prop-types'
import { keys } from 'ramda'
import classnames from 'classnames'
import { timer } from 'rxjs'

import Episode from './episode'
import { SeasonType } from '../prop-types'
import { EpisodeSelectorUiConsumer } from '../episode-selector-ui'
import EmblaCarousel from '../../../../emblaCarousel'
import { getResponsiveEpisodeShowCount } from '../../../../../lib/utils'
import styles from './selector-carousel.css'

class SelectorCarousel extends React.PureComponent {
  constructor(props) {
    super(props)

    this.delayUpdateSeason = this.delayUpdateSeason.bind(this)
    this.getSafeFocusIndex = this.getSafeFocusIndex.bind(this)

    this.state = {
      season: props.season,
      isShown: true,
      focusIndex: keys(props.season).indexOf(props.activeEpisode)
    }
  }

  componentDidUpdate(prevProps, _, season) {
    if (prevProps.season !== this.props.season) {
      this.delayUpdateSeason(season)
    }
  }

  componentWillUnmount() {
    if (this.delayUpdateSeasonSubscription) {
      this.delayUpdateSeasonSubscription.unsubscribe()
    }
  }

  getSafeFocusIndex(season) {
    const { activeEpisode } = this.props
    const episodeNumberArray = keys(season)
    const focusIndex = episodeNumberArray.indexOf(activeEpisode)
    return Math.max(0, focusIndex)
  }

  getSnapshotBeforeUpdate(prevProps) {
    if (prevProps.season !== this.props.season) {
      return this.props.season
    }
    return null
  }

  // We need to delay the update of seasons
  // by set prop.season to state.season and delay 300ms.
  // Because the new season will show before the transition finish
  // Instead of seeing it AFTER the transition
  delayUpdateSeason(season) {
    this.setState({ isShown: false }, () => {
      this.delayUpdateSeasonSubscription = timer(300).subscribe(() => {
        this.setState({
          isShown: true,
          season,
          focusIndex: this.getSafeFocusIndex(season)
        })
      })
    })
  }

  render() {
    const { activeEpisode } = this.props
    const { season, isShown, focusIndex } = this.state

    const episodeNumberArray = keys(season)
    const slideCount = getResponsiveEpisodeShowCount(window.innerWidth, 2)

    return (
      <EpisodeSelectorUiConsumer>
        {({ loadedImagery }) => {
          const isImageAllLoaded = loadedImagery === episodeNumberArray.length
          const isCarouselShown = isImageAllLoaded && isShown
          const episodeItems = episodeNumberArray.map(episodeNumber => ({
            ...season[episodeNumber],
            isActive: activeEpisode === episodeNumber
          }))
          const carouselKey = episodeItems
            .map(episode => `${episode.seasonNumber}-${episode.episodeNumber}`)
            .join('|')

          return (
            <div
              className={classnames(styles.wrapper, {
                [styles.loaded]: isCarouselShown
              })}
            >
              <EmblaCarousel
                key={carouselKey}
                startSlideIndex={focusIndex}
                slidesToShow={slideCount}
                activeSlideCount={episodeItems.length}
                emblaButtonsCustomStyle={styles.arrowButton}
              >
                {episodeItems.map((episode, index) => (
                  <div
                    className={styles.emblaSlide}
                    key={episode.id || index}
                  >
                    <Episode
                      episode={episode}
                      active={episode.isActive}
                    />
                  </div>
                ))}
              </EmblaCarousel>
            </div>
          )
        }}
      </EpisodeSelectorUiConsumer>
    )
  }
}

SelectorCarousel.propTypes = {
  season: SeasonType.isRequired,
  activeEpisode: PropTypes.string.isRequired
}

export default SelectorCarousel
